import { forwardRef } from 'react';
import { View } from 'react-native';

import { TooltipProvider } from './TooltipContext';
import type { TooltipProps } from './types';

const Tooltip = forwardRef<View, TooltipProps>(
  (
    { children, placement = 'top', delayShow = 0, delayHide = 0, ...props },
    ref,
  ) => {
    return (
      <TooltipProvider
        placement={placement}
        delayShow={delayShow}
        delayHide={delayHide}
      >
        <View ref={ref} {...props}>
          {children}
        </View>
      </TooltipProvider>
    );
  },
);

Tooltip.displayName = 'Tooltip';

export { Tooltip };
